import {Component, OnInit} from '@angular/core';
import {
    AdminDashboardApiService,
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig, DataTableDataSource, DataTableObservableCompletionListener,
    DataTableObservableDataSource, DataTableObservableErrorListener,
    DataTableObservableRefresher,
    TableAction
} from '@cas-hub/acabim-common-client';
import {map} from 'rxjs/operators';

export interface SiteStatsModel {
    siteName: string;
    projectCount: number;
}

@Component({
    selector: 'acabim-admin-project-building-status',
    templateUrl: './project-building-status.component.html',
    styleUrls: ['./project-building-status.component.scss']
})
export class ProjectBuildingStatusComponent implements OnInit {
    public dataSources: DataTableDataSource<any>[] = [];

    constructor(private readonly adminDashboardService: AdminDashboardApiService) {
    }

    ngOnInit(): void {
        this.dataSources.push(new SiteStats(this.siteDS, undefined, undefined));

    }

    private get siteDS(): DataTableObservableRefresher<SiteStatsModel> {
        return () => this.adminDashboardService.getSiteProjectStats()
            .pipe(map(data => {
                const statsTable: SiteStatsModel[] = [];
                data.forEach(site => {
                    const records: SiteStatsModel = {siteName: site.site.name, projectCount: site.projects.length};
                    statsTable.push(records);
                });
                return statsTable;
            }));
    }


}

export class SiteStats<T extends SiteStatsModel> extends DataTableObservableDataSource<T> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Site Name', objectPropertyName: 'siteName', colWidth: '78%'},
            {displayName: 'Project Count', objectPropertyName: 'projectCount', colWidth: '22%', textAlign: 'center'}
        ];
    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: false,
        searchPlaceHolder: 'Search Space',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: false,
        hasDetailsButton: false,
        isLazyLoadingEnabled: false,
        isPaginationEnabled: false,
        hasFilters: false,
        isExportEnabled: false,
        hasActions: false
    };
    readonly columnFilters: ColumnFilter[] = [];
    readonly actions: TableAction[] = [];

    onDataExpanded(value: SiteStatsModel): void {
    }

    constructor(readonly dataRefresher: DataTableObservableRefresher<T>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(() => this.dataRefresher(), observableErrorListener, observableCompleteListener);
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }

}
